var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.divstyle)},[_c('div',{style:(_vm.linestyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }